// extracted by mini-css-extract-plugin
export var menuIcon = "_sb-0";
export var menuIconInline = "_sb-1";